import React from 'react';
import Routes from './Routes';
import { SVG_BACKGROUND } from '../constants'

function App() {
  return (
    <div style={SVG_BACKGROUND}>
      <Routes/>
    </div>
  );
}

export default App;


